module.exports = __webpack_public_path__ + "static/img/sm5.3b4adc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm5.png
// module id = 8Bnj
// module chunks = 1